import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import Wrapper, { Notification } from "../components/Wrapper";
import { setToken, setUsername } from "../redux/slices/authSlice";

const AutoLogin = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const token = params.get("token") || params.get("x_token") || "";
  const username =
    params.get("username") || params.get("user") || params.get("email") || "";

  useEffect(() => {
    if (!token) return;

    dispatch(setToken(token));
    if (username) {
      dispatch(setUsername(username));
    }
    history.replace("/");
  }, [dispatch, history, token, username]);

  return (
    <Wrapper>
      <Notification>
        {token ? "Signing in..." : "Magic link is missing a token."}
      </Notification>
    </Wrapper>
  );
};

export default AutoLogin;
